// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.global[data-v-5d4fff74] {
  margin-bottom: 0px;
}
div.local[data-v-5d4fff74] {
  margin-top: 0px;
}
.list-item[data-v-5d4fff74] {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  height: auto;
  background-color: var(--list-item-bgcolor);
  margin-bottom: var(--list-item-margin);
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.list-item.active[data-v-5d4fff74] {
  background-color: var(--list-item-activebgcolor);
}
.list-item[data-v-5d4fff74]:not(.no-hover):hover {
  background-color: var(--list-item-bghover);
  cursor: pointer;
}
.list-item:not(:last-child) .item-content[data-v-5d4fff74]::after {
  content: " ";
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 1px;
  border-bottom: 1px solid var(--message-bg-color2);
}
.list-item .item-media[data-v-5d4fff74],
.list-item .item-text[data-v-5d4fff74],
.list-item .item-after[data-v-5d4fff74],
.list-item .item-link[data-v-5d4fff74] {
  margin: auto 0;
}
.list-item .item-media[data-v-5d4fff74]:first-child,
.list-item .item-text[data-v-5d4fff74]:first-child,
.list-item .item-after[data-v-5d4fff74]:first-child,
.list-item .item-link[data-v-5d4fff74]:first-child {
  margin-left: 15px;
}
.list-item .item-media[data-v-5d4fff74]:last-child,
.list-item .item-text[data-v-5d4fff74]:last-child,
.list-item .item-after[data-v-5d4fff74]:last-child,
.list-item .item-link[data-v-5d4fff74]:last-child {
  margin-right: 8px;
}
.list-item .item-content[data-v-5d4fff74] {
  position: relative;
  display: flex;
  flex-direction: row;
  flex: 1 1;
  overflow: hidden;
  height: var(--list-item-height);
  line-height: initial;
}
.list-item .item-content .item-text[data-v-5d4fff74] {
  display: flex;
  flex-direction: column;
  flex: 1;
}
.list-item .item-content .item-text .item-title[data-v-5d4fff74],
.list-item .item-content .item-text .item-header[data-v-5d4fff74],
.list-item .item-content .item-text .item-footer[data-v-5d4fff74] {
  text-overflow: ellipsis;
  overflow: hidden;
}
.list-item .item-content .item-text .item-title[data-v-5d4fff74] {
  font-size: 16px;
}
.list-item .item-content .item-text .item-title-html[data-v-5d4fff74] {
  overflow-wrap: anywhere;
  margin-top: 4px;
  margin-bottom: 4px;
}
.list-item .item-content .item-text .item-title-html[data-v-5d4fff74] span a {
  color: var(--ref-link-color) !important;
  display: flex;
  flex-direction: column;
}
.list-item .item-content .item-text .item-header[data-v-5d4fff74],
.list-item .item-content .item-text .item-footer[data-v-5d4fff74] {
  font-size: 14px;
  color: var(--listitem-headerfooter-color);
}
.list-item .item-content span.item-after[data-v-5d4fff74] {
  font-size: 16px;
  color: var(--toolbtn-active-color);
  padding: 8px;
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./js/app/components/custom/CustomListItem.vue"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,0CAA0C;EAC1C,sCAAsC;EACtC,2BAA2B;EAC3B,yBAAyB;EACzB,wBAAwB;EACxB,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE,gDAAgD;AAClD;AACA;EACE,0CAA0C;EAC1C,eAAe;AACjB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,iDAAiD;AACnD;AACA;;;;EAIE,cAAc;AAChB;AACA;;;;EAIE,iBAAiB;AACnB;AACA;;;;EAIE,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,+BAA+B;EAC/B,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,OAAO;AACT;AACA;;;EAGE,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,uBAAuB;EACvB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,uCAAuC;EACvC,aAAa;EACb,sBAAsB;AACxB;AACA;;EAEE,eAAe;EACf,yCAAyC;AAC3C;AACA;EACE,eAAe;EACf,kCAAkC;EAClC,YAAY;EACZ,eAAe;AACjB","sourcesContent":["div.global[data-v-5d4fff74] {\n  margin-bottom: 0px;\n}\ndiv.local[data-v-5d4fff74] {\n  margin-top: 0px;\n}\n.list-item[data-v-5d4fff74] {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  height: auto;\n  background-color: var(--list-item-bgcolor);\n  margin-bottom: var(--list-item-margin);\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n  -khtml-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n.list-item.active[data-v-5d4fff74] {\n  background-color: var(--list-item-activebgcolor);\n}\n.list-item[data-v-5d4fff74]:not(.no-hover):hover {\n  background-color: var(--list-item-bghover);\n  cursor: pointer;\n}\n.list-item:not(:last-child) .item-content[data-v-5d4fff74]::after {\n  content: \" \";\n  position: absolute;\n  bottom: 0;\n  width: 100%;\n  height: 1px;\n  border-bottom: 1px solid var(--message-bg-color2);\n}\n.list-item .item-media[data-v-5d4fff74],\n.list-item .item-text[data-v-5d4fff74],\n.list-item .item-after[data-v-5d4fff74],\n.list-item .item-link[data-v-5d4fff74] {\n  margin: auto 0;\n}\n.list-item .item-media[data-v-5d4fff74]:first-child,\n.list-item .item-text[data-v-5d4fff74]:first-child,\n.list-item .item-after[data-v-5d4fff74]:first-child,\n.list-item .item-link[data-v-5d4fff74]:first-child {\n  margin-left: 15px;\n}\n.list-item .item-media[data-v-5d4fff74]:last-child,\n.list-item .item-text[data-v-5d4fff74]:last-child,\n.list-item .item-after[data-v-5d4fff74]:last-child,\n.list-item .item-link[data-v-5d4fff74]:last-child {\n  margin-right: 8px;\n}\n.list-item .item-content[data-v-5d4fff74] {\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  flex: 1 1;\n  overflow: hidden;\n  height: var(--list-item-height);\n  line-height: initial;\n}\n.list-item .item-content .item-text[data-v-5d4fff74] {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n}\n.list-item .item-content .item-text .item-title[data-v-5d4fff74],\n.list-item .item-content .item-text .item-header[data-v-5d4fff74],\n.list-item .item-content .item-text .item-footer[data-v-5d4fff74] {\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n.list-item .item-content .item-text .item-title[data-v-5d4fff74] {\n  font-size: 16px;\n}\n.list-item .item-content .item-text .item-title-html[data-v-5d4fff74] {\n  overflow-wrap: anywhere;\n  margin-top: 4px;\n  margin-bottom: 4px;\n}\n.list-item .item-content .item-text .item-title-html[data-v-5d4fff74] span a {\n  color: var(--ref-link-color) !important;\n  display: flex;\n  flex-direction: column;\n}\n.list-item .item-content .item-text .item-header[data-v-5d4fff74],\n.list-item .item-content .item-text .item-footer[data-v-5d4fff74] {\n  font-size: 14px;\n  color: var(--listitem-headerfooter-color);\n}\n.list-item .item-content span.item-after[data-v-5d4fff74] {\n  font-size: 16px;\n  color: var(--toolbtn-active-color);\n  padding: 8px;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
